class Notifications {
    constructor(notificationsJson, options = {}){
        this.options = Object.assign(
            {},
            {    
                config: ""
            }, 
            options
        );    

        //Variables  
        this.notifications = notificationsJson.notifications; 
        this.notifications_count = notificationsJson.notifications_count;  
        this.contentNotificationsFront = document.querySelector("#notifs #notifications .content-notifications");
        this.contentPictoNotificationsCount = document.querySelector("#notifs .content-picto-notifs .count");
        this.contentNotifPicto = document.querySelector("#notifs .content-picto-notifs");
        this.closeNotifs = document.querySelector("#notifs #notifications .close-notifications"); 
        this.buildNotifications(this.notifications);

        this.contentNotifPicto.addEventListener("click", () => {
            this.contentNotifPicto.closest("#notifs").classList.toggle("open");
            this.updateCookieNotif(this.notifications_count);
            this.contentPictoNotificationsCount.classList.add("off");
        });

        this.closeNotifs.addEventListener("click", () => {
            this.contentNotifPicto.closest("#notifs").classList.toggle("open"); 
        });

        if(document.querySelector(".content-sub-news")){
            document.querySelector(".content-sub-news .news .sub-news").addEventListener("click", () => {
                document.querySelector(".content-sub-news .news .sub-news").classList.add("loading");
                let email =  document.querySelector(".content-sub-news .news #email-sub").value;
                this.checkKlaviyo(email);
                //this.subKlaviyo(email);
            }); 
        }

    }  

    buildNotifications(notifs){ 
        let arImage = [];
        notifs.forEach(notif => {
            let contentNotif = this.createElementWithClass("a", "notification");
            contentNotif.href = notif.url;
            if (notif.url_new_window == true) {
                contentNotif.target = "new";
            }
            let contentNotifImg = this.createElementWithClass("div", "content-img");
            let imgNotif = this.createElementWithClass("img", "img-notif");
            imgNotif.classList.add("lazy");
            imgNotif.classList.add("ext");
            imgNotif.setAttribute("data-src", notif.img);
            imgNotif.setAttribute("alt", contentNotif);
            contentNotifImg.appendChild(imgNotif);
            let contentNotifDesc = this.createElementWithClass("div", "content-desc");
            contentNotifDesc.innerHTML = notif.desc;
            contentNotif.appendChild(contentNotifImg);  
            contentNotif.appendChild(contentNotifDesc); 
            this.contentNotificationsFront.appendChild(contentNotif); 
            arImage.push(imgNotif); 
        }); 
        new LazyImg(arImage);
        this.notifToShow(this.notifications_count, true);
    }

    notifToShow(nb, force){
        if(force){
            var checkCookie = 0;
        }else{
            var checkCookie = this.checkCookie();
        }
        if(checkCookie == false){
            this.contentPictoNotificationsCount.textContent = nb;
            this.contentPictoNotificationsCount.classList.remove("off");
        }else{
            if(nb > checkCookie){
                this.contentPictoNotificationsCount.textContent = nb - checkCookie; 
                this.contentPictoNotificationsCount.classList.remove("off");
            }else{
                this.contentPictoNotificationsCount.textContent = "";
                this.contentPictoNotificationsCount.classList.add("off");
            }
        } 
    }

    updateCookieNotif(nb){
        this.setCookie("notifications", nb, 7);
    }

    checkCookie(){
        if(this.getCookie("notifications") != null){
            return parseInt(this.getCookie("notifications"));
        }else{
            return false;
        }
    }

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    } 

    async checkKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id})  
        };
        const call = await fetch(`${app.aws.url}/klaviyo/checklist`, options);  
        const rep = await call.json();  
        if(JSON.parse(rep.rep.body).length > 0){ 
            document.querySelector(".content-sub-news .news .sub-news").classList.remove("loading");
            document.querySelector(".content-sub-news .success").textContent = "Vous faites déjà parti de nos abonné(e)s !";
            document.querySelector(".content-sub-news .success").classList.add("ok");
            document.querySelector(".content-sub-news .news").classList.add("hide");
        }else{
            console.log("sub");
            this.subKlaviyo(dataEmail); 
        } 
    }

    async subKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail,listId: 'KKzsmr', source: "wisp"})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/subscribe`, options);  
        const rep = await call.json();  
        if(typeof rep.statut != "undefined" && rep.statut == "save"){
            console.log("success");
            document.querySelector(".content-sub-news .news .sub-news").classList.remove("loading");
            document.querySelector(".content-sub-news .success").classList.add("ok");
            document.querySelector(".content-sub-news .news").classList.add("hide");
        }  
    }

     
} 